export default __webpack_public_path__ + "static/media/pic1.fd62450b.png";